import { Box } from '../../Box';
export var AnimatedBox = Box;
//# sourceMappingURL=Animated.js.map